// extracted by mini-css-extract-plugin
module.exports = {"container":"pay-sdk-payment-recommendation__container___2zabW"};